<!-- 连续出版物核验登记 -->

<template>
  <div class="province-8">
    <div class="ttBar">
      <span>出版连续型电子出版物单位登记</span>
    </div>
    <div class="tabArea" v-loading="loading">
      <div class="ctrlsBar">

        <div class="blockRt">
          <!-- <el-select v-model="postDat.status" @change="tabSeek('init')" size="small" placeholder="请选择">
                        <el-option
                          v-for="item in staArr"
                          :key="item.key"
                          :label="item.name"
                          :value="item.key">
                        </el-option>
                    </el-select> -->
          <el-select v-model="postDat.status" @change="tabSeek('init')" size="small" placeholder="请选择">
            <el-option v-for="item in typeArr" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select>

          <el-input v-model="postDat.keyword" size="small" placeholder="通过单位名称、出版物名称查询"></el-input>
          <!-- <el-button @click="tabSeek('init')" size="small">查询</el-button> -->
        </div>
      </div>
      <div>
        <!-- @selection-change="selectionChange" -->
        <el-table :data="tabDats" border style="width: 100%">
          <!-- <el-table-column :selectable="checkDfine" type="selection" width="45" align="center"></el-table-column> -->
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + 15*(postDat.no - 1) }}
            </template>
          </el-table-column>
          <el-table-column prop="organizationName" label="出版单位" align="center">
          </el-table-column>
          <el-table-column prop="name" label="出版物名称" align="center">
          </el-table-column>
          <el-table-column width="150" label="查阅时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.provinceConsult | transStr('time') }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="provinceConsult" width="150" label="查阅时间" align="center">
					 							   <template slot-scope="scope">
                                 {{ scope.row.provinceConsult | transStr('time') }}
													 </template>
                      </el-table-column> -->
          <el-table-column width="150" label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row | transStr('record_state') }}</span>
            </template>
          </el-table-column>
          <el-table-column width="180" label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.record == 1" @click="goRegist(scope.row)" type="primary" size="mini">登记
              </el-button>
              <el-button @click="goScan(scope.row)" type="primary" size="mini">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pageCage" v-if="pgAll > 1">
          <el-pagination @current-change="pageSent" :current-page='postDat.no' layout="prev, pager, next"
            :page-count="pgAll">
          </el-pagination>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    successiveRegistList,
    goRegist
  } from '@/api/provinceRole/provinceRole';
  export default {

    data() {
      return {

        // 登记状态组
        typeArr: [{
            name: '全部',
            key: 0
          },
          {
            name: '未登记',
            key: 1
          },
          {
            name: '已登记',
            key: 2
          }
        ],

        // 核验状态组
        staArr: [{
            name: '全部',
            key: 99
          },
          {
            name: '通过',
            key: 1
          },
          {
            name: '暂缓',
            key: 2
          },
          {
            name: '撤销',
            key: 4
          },
          {
            name: '注销',
            key: 5
          }
        ],

        loading: false,
        postDat: {
          status: 0,
          record: 0,
          keyword: '',

          no: 1,
          size: 15
        },

        tabDats: [],
        tabDatsAll: [],
        pgAll: 0,
      }
    },

    filters: {
      transStr: function (row, code) {
        if (code == 'record_state') {
          if (row.record == 1) {
            return '未登记';
          } else if (row.record == 2) {
            return '已登记';
          }
        } else if (code == 'state') {
          let map = {
            1: '通过',
            2: '暂缓',
            4: '撤销',
            5: '注销'
          }
          return map[row.pubStatus];
        } else if (code == 'time') {
          if(row=='Invalid date' || !row){
            return "";
          }
          return row.substr(0, 16);
        }
      }
    },

    watch: {
      postDat: {
        deep: true, //实现深度监听
        handler(v) {
          if(!v.goPage){
            this.postDat.no = 1;
          }
          this.postDat.goPage = false;
          this.filterTableData()
        }
      }
    },
    methods: {
      tabSeek: function (code) {
        if (code == 'init') {
          this.postDat.no = 1;
        };
        this.loading = true;
        successiveRegistList(this.postDat).then(response => {        
          // console.log('response=',JSON.stringify(response));  
          this.loading = false;
          this.tabDatsAll = response.provinceRecordList;

          this.filterTableData();
        });
      },
      // zym.过滤列表数据
      filterTableData: function () {
        let tabDats = this.tabDatsAll;

        let qType = this.postDat.status;
        let qKeyword = this.postDat.keyword;
        // !状态
        if (qType!='0') {
          tabDats = tabDats.filter(function (item) {            
            // zym.待核验
            if(qType==1 && item.record=='1'){
              return true;
            }
            else if(qType==2 && item.record=='2'){
              return true;
            }
            return false;
          });
        }
        // !关键字查询
        if (qKeyword) {
          tabDats = tabDats.filter(function (item) {
            if ((item.organizationName || '').indexOf(qKeyword) > -1 || (item.name || '').indexOf(qKeyword) > -1) {
              return true;
            }
            return false;
          });
        }

        this.tabDats = tabDats;
        
        // 计算分页信息
        this.calPage();      
      },
      // 计算分页信息
      calPage:function(tabDatsTemp){
        let postDat = this.postDat;
        let tabDatsAll = this.tabDats;
        // console.log('postDat=',JSON.stringify(tabDatsAll));
        let dataLen = Number(tabDatsAll.length);
        // console.log('dataLen=',dataLen);
        let size = Number(postDat.size);
        // console.log('size=',size);
        let total = Math.floor(dataLen/size);
        // console.log('total=',total);
        this.tabDats = tabDatsAll.slice((postDat.no-1)*size,postDat.no*size);
        
        if(dataLen%size!=0){
          total = Math.floor(dataLen/size) + 1;
        }
        postDat['total'] = total;
        this.postDat = postDat;
      },
      pageSent: function (inx) {
        this.postDat.no = inx;
        this.postDat.goPage = true;
        // this.tabSeek();
      },

      goRegist: function (row) {
        let vm = this;
        this.$confirm('确认登记吗？', '提示', {
          confirmButtonText: '登记',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {   
          const loading = vm.$loading({
            lock: true,
            text: '处理中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          goRegist({
            id: row.id
          }).then(response => {
            loading.close();

            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.tipMessage || '操作失败';
            if (tipCode == 'fail') {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: 'error'
              })
            }
            else {
              this.$message({
                message: tipMessage,
                type: 'success',
                onClose:function(){      
                  vm.tabSeek('init');
                }
              })
            }
          })
        }).catch(() => {});
      },

      goScan: function (inDat) {
        this.$router.push({
          path: 'successive_skim',
          query: {
            pressId: inDat.organizationId,
            listId: inDat.publishMaterialId,
            pressState: 2,
            examId: inDat.materialExamineId,
            bookName: inDat.name,
            pressName: inDat.organizationName,
          }
        })
      }
    },

    created: function () {
      this.tabSeek();
    }

  }
</script>

<style lang="scss">
  @import "src/styles/provinceCom";

  .province-8 {
    padding: 9px;

    .ttBar {
      height: 45px;
      line-height: 45px;
      background: #f8f8f8;
      font-size: 14px;
      padding: 0px 20px;
      color: #666666;
      font-weight: bold;
    }

    .ctrlsBar {
      height: 32px;
      margin-top: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// successiveRegist.vue?0ccd2caa